import { createApiInstance } from './config'

const gamesAPI = createApiInstance()

export default {
  // 获取游戏推荐列表
  getGameRecommendations() {
    return gamesAPI.get('/games/recommendations')
  }
}
